import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-keep-home',
    templateUrl: './keep-home.component.html',
    styleUrls: ['./keep-home.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class KeepHomeComponent {

}
